// Canonical display labels for strategy types.
// API values (PYRAMID_HEDGING, DELTA_HEDGED_SHORT_STRANGLE) never change —
// only the text shown to users is controlled here.

export const STRATEGY_LABELS = {
  PYRAMID_HEDGING:             "Pyramid Hedging",
  DELTA_HEDGED_SHORT_STRANGLE: "DHSS",
  FUTURES_PYRAMID_HEDGING:     "Futures Pyramid Hedging (FPH)",
  WEEKLY_INDEX_SHORT_STRADDLE: "Weekly Index Short Straddle (WISS)",
};

/** Returns the human-readable label for a strategy type value. */
export const strategyLabel = (type) => STRATEGY_LABELS[type] || type;

const _ALL_STRATEGY_OPTIONS = [
  { value: "PYRAMID_HEDGING",             label: "Pyramid Hedging" },
  { value: "DELTA_HEDGED_SHORT_STRANGLE", label: "DHSS" },
  { value: "FUTURES_PYRAMID_HEDGING",     label: "Futures Pyramid Hedging (FPH)" },
  { value: "WEEKLY_INDEX_SHORT_STRADDLE", label: "Weekly Index Short Straddle (WISS)" },
];

// Per-VPS strategy types to hide from the picker (window.APP_CONFIG is set by
// /app-config.js, served before the React bundle loads — see
// routes/branding_routes.py). Not synced across the fleet by design: each
// deployment's app_settings is its own isolated DB, so this only affects the
// VPS it was configured on.
const _hiddenStrategyTypes = new Set(window.APP_CONFIG?.hiddenStrategyTypes || []);

/** Ordered list used for dropdowns. */
export const STRATEGY_OPTIONS = _ALL_STRATEGY_OPTIONS.filter(
  (opt) => !_hiddenStrategyTypes.has(opt.value)
);
